import React from "react";

const YES_NO_NA = ["Yes", "No", "NA"];

const normalize = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v).trim();
  if (/^n\/?a$/i.test(s)) return "NA";
  if (/^yes$/i.test(s)) return "Yes";
  if (/^no$/i.test(s)) return "No";
  return s;
};

/**
 * 14030 — Large radio-card style answer for Yes/No/NA. Read-only — clicks
 * are inert; the selected option highlights to mirror the vendor's
 * submitted answer.
 */
const RadioCard = ({ label, selected }) => {
  const dot = selected ? (
    <span className="inline-flex h-4 w-4 items-center justify-center rounded-full border-[2px] border-indigo-600">
      <span className="h-2 w-2 rounded-full bg-indigo-600" />
    </span>
  ) : (
    <span className="inline-flex h-4 w-4 rounded-full border-[2px] border-gray-300" />
  );

  return (
    <div
      className={`flex items-center gap-2 rounded-md border px-4 py-2.5 text-sm w-32 ${
        selected
          ? "border-indigo-500 bg-indigo-50 text-indigo-700 ring-1 ring-indigo-200"
          : "border-gray-300 bg-white text-gray-700"
      }`}
    >
      {dot}
      <span className="font-medium">{label}</span>
    </div>
  );
};

const AnswerSelect = ({ value }) => {
  const v = normalize(value);

  if (YES_NO_NA.includes(v) || v === "") {
    return (
      <div>
        <div className="text-[11px] uppercase tracking-wide text-gray-500 mb-1.5">Yes/No/NA*</div>
        <div className="flex flex-wrap gap-2">
          {YES_NO_NA.map((opt) => (
            <RadioCard key={opt} label={opt} selected={v === opt} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-200">
      {value}
    </span>
  );
};

export default AnswerSelect;
